export const NUVELOR_THEME_STORAGE_KEY = "nuvelor_theme";
export const NUVELOR_THEME_LIGHT = "light";
export const NUVELOR_THEME_DARK = "dark";
export const NUVELOR_THEME_CHANGE_EVENT = "nuvelor-theme-change";

export function normalizeNuvelorTheme(value) {
  return value === NUVELOR_THEME_LIGHT ? NUVELOR_THEME_LIGHT : NUVELOR_THEME_DARK;
}

export function getStoredNuvelorTheme() {
  if (typeof window === "undefined") return NUVELOR_THEME_DARK;

  try {
    return normalizeNuvelorTheme(window.localStorage.getItem(NUVELOR_THEME_STORAGE_KEY));
  } catch {
    return NUVELOR_THEME_DARK;
  }
}

export function applyNuvelorTheme(theme) {
  const nextTheme = normalizeNuvelorTheme(theme);

  if (typeof document !== "undefined") {
    document.documentElement.dataset.nuvelorTheme = nextTheme;
  }

  return nextTheme;
}

export function setStoredNuvelorTheme(theme) {
  const nextTheme = applyNuvelorTheme(theme);

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(NUVELOR_THEME_STORAGE_KEY, nextTheme);
      window.dispatchEvent(new CustomEvent(NUVELOR_THEME_CHANGE_EVENT, { detail: nextTheme }));
    } catch {
      return nextTheme;
    }
  }

  return nextTheme;
}

export function initializeNuvelorTheme() {
  return applyNuvelorTheme(getStoredNuvelorTheme());
}

export function getCurrentNuvelorTheme() {
  if (typeof document !== "undefined") {
    const current = document.documentElement?.dataset?.nuvelorTheme;
    if (current === NUVELOR_THEME_LIGHT || current === NUVELOR_THEME_DARK) return current;
  }
  return getStoredNuvelorTheme();
}

export function subscribeNuvelorTheme(listener) {
  if (typeof window === "undefined") return () => {};

  const handleThemeChange = () => listener();
  const handleStorage = (event) => {
    if (event.key === NUVELOR_THEME_STORAGE_KEY) {
      applyNuvelorTheme(getStoredNuvelorTheme());
      listener();
    }
  };

  window.addEventListener(NUVELOR_THEME_CHANGE_EVENT, handleThemeChange);
  window.addEventListener("storage", handleStorage);
  return () => {
    window.removeEventListener(NUVELOR_THEME_CHANGE_EVENT, handleThemeChange);
    window.removeEventListener("storage", handleStorage);
  };
}
